import api from '@mint-lib/api';
import { TFunction } from '@mint-lib/i18n';
import { enqueueSnackbar } from '@mint-lib/notifications-api';

import { USER_CURRENCY } from '../endpoints.js';

export const setUserCurrency = async (
  mainCurrencyId: string,
  t: TFunction,
): Promise<null> => {
  return api
    .patch(`${USER_CURRENCY}`, { main_currency_id: mainCurrencyId })
    .then((data) => {
      enqueueSnackbar({
        title: t('Success'),
        subTitle: t('User currency has been changed successfully.'),
        variant: 'success',
      });

      // its null {data null, error null} due to BE implementation
      // you should refetch getUserCurrency and set it separately
      return null;
    })
    .catch((e) => {
      enqueueSnackbar({
        title: t('Error'),
        subTitle:
          e?.response?.data?.error?.message ||
          t('Unable to set user currency.'),
        variant: 'error',
      });

      return null;
    });
};
